<template>
  <div class="track-order">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <router-link to="/">{{ $t('page.index.navTitle') }}</router-link>
      <span class="separator">></span>
      <span class="current">{{ $t('page.index.trackOrder' )}}</span>
    </div>

    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="title">{{ $t('page.trackOrder.title' )}}</h1>
      <p class="description">
        {{ $t('page.trackOrder.tips') }}
      </p>
    </div>

    <!-- 查询表单 -->
    <div class="track-form">
      <div class="form-row">
        <div class="form-group">
          <label for="orderId">{{ $t('page.trackOrder.orderId') }}</label>
          <input
            id="orderId"
            v-model="formData.orderId"
            type="text"
            class="form-input"
          />
        </div>
        
        <div class="form-group">
          <label for="billingEmail">{{ $t('page.trackOrder.email') }}</label>
          <input
            id="billingEmail"
            v-model="formData.billingEmail"
            type="email"
            class="form-input"
          />
        </div>
      </div>

      <button 
        @click="trackOrder" 
        :disabled="!canTrack"
        class="track-button"
      >
        {{ $t('page.trackOrder.btnTxt') }}
      </button>
    </div>

    <!-- 订单结果 -->
    <!-- <div v-if="orderResult" class="order-result">
      <div class="order-card">
        <h3>Order Details</h3>
        <div class="order-info">
          <p><strong>Order ID:</strong> {{ orderResult.orderId }}</p>
          <p><strong>Status:</strong> <span :class="'status-' + orderResult.status.toLowerCase()">{{ orderResult.status }}</span></p>
          <p><strong>Order Date:</strong> {{ formatDate(orderResult.orderDate) }}</p>
          <p><strong>Total Amount:</strong> ${{ orderResult.totalAmount }}</p>
        </div>
        
        <div v-if="orderResult.trackingInfo" class="tracking-info">
          <h4>Tracking Information</h4>
          <div class="tracking-steps">
            <div 
              v-for="(step, index) in orderResult.trackingInfo" 
              :key="index"
              :class="['tracking-step', { 'completed': step.completed, 'current': step.current }]"
            >
              <div class="step-icon">
                <i :class="step.icon"></i>
              </div>
              <div class="step-content">
                <h5>{{ step.title }}</h5>
                <p>{{ step.description }}</p>
                <span v-if="step.date" class="step-date">{{ formatDate(step.date) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 错误信息 -->
    <!-- <div v-if="errorMessage" class="error-message">
      <p>{{ errorMessage }}</p>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'TrackOrder',
  data() {
    return {
      formData: {
        orderId: '',
        billingEmail: ''
      },
      orderResult: null,
      errorMessage: '',
      loading: false
    }
  },
  computed: {
    canTrack() {
      return this.formData.orderId.trim() && this.formData.billingEmail.trim()
    }
  },
  methods: {
    async trackOrder() {
      if (!this.canTrack) return
      
      this.loading = true
      this.errorMessage = ''
      this.orderResult = null
      
      try {
        const res = await this.$axios.post('/api/index/lookOrder', {
            orderid: this.formData.orderId,
            email: this.formData.billingEmail,
        })
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: this.$t('page.trackOrder.successTip')
          })
        }
      } catch (error) {
        console.error('Track order error:', error)
      } finally {
        this.loading = false
      }
    },
    
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.track-order {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f8f9fa;
  min-height: 100vh;

  .breadcrumb {
    margin-bottom: 30px;
    font-size: 14px;
    color: #6c757d;

    a {
      color: #6c757d;
      text-decoration: none;

      &:hover {
        color: #e93323;
      }
    }

    .separator {
      margin: 0 8px;
    }

    .current {
      color: #495057;
    }
  }

  .page-header {
    text-align: center;
    margin-bottom: 50px;

    .title {
      font-size: 36px;
      font-weight: 300;
      color: #495057;
      margin-bottom: 20px;
    }

    .description {
      font-size: 16px;
      color: #6c757d;
      line-height: 1.6;
      max-width: 800px;
      margin: 0 auto;
    }
  }

  .track-form {
    background-color: #fff;
    padding: 40px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;

    .form-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 30px;
      margin-bottom: 30px;

      @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 20px;
      }
    }

    .form-group {
      label {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: #495057;
        margin-bottom: 8px;
      }

      .form-input {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #dee2e6;
        border-radius: 4px;
        font-size: 16px;
        transition: border-color 0.3s ease;

        &:focus {
          outline: none;
          border-color: #e93323;
          box-shadow: 0 0 0 2px rgba(233, 51, 35, 0.1);
        }

        &::placeholder {
          color: #adb5bd;
        }
      }
    }

    .track-button {
      background-color: #e93323;
      color: white;
      border: none;
      padding: 12px 30px;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      transition: background-color 0.3s ease;

      &:hover:not(:disabled) {
        background-color: #d12b1f;
      }

      &:disabled {
        background-color: #adb5bd;
        cursor: not-allowed;
      }
    }
  }

  .order-result {
    .order-card {
      background-color: #fff;
      padding: 30px;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

      h3 {
        font-size: 24px;
        color: #495057;
        margin-bottom: 20px;
        border-bottom: 2px solid #e93323;
        padding-bottom: 10px;
      }

      .order-info {
        margin-bottom: 30px;

        p {
          margin-bottom: 10px;
          font-size: 16px;
          color: #495057;

          strong {
            font-weight: 600;
          }
        }

        .status-shipped {
          color: #28a745;
          font-weight: 600;
        }

        .status-processing {
          color: #ffc107;
          font-weight: 600;
        }

        .status-delivered {
          color: #17a2b8;
          font-weight: 600;
        }
      }

      .tracking-info {
        h4 {
          font-size: 20px;
          color: #495057;
          margin-bottom: 20px;
        }

        .tracking-steps {
          .tracking-step {
            display: flex;
            align-items: flex-start;
            margin-bottom: 20px;
            position: relative;

            &:not(:last-child)::after {
              content: '';
              position: absolute;
              left: 20px;
              top: 45px;
              width: 2px;
              height: 40px;
              background-color: #dee2e6;
            }

            &.completed::after {
              background-color: #28a745;
            }

            .step-icon {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 15px;
              background-color: #dee2e6;
              color: #6c757d;
              flex-shrink: 0;

              i {
                font-size: 16px;
              }
            }

            &.completed .step-icon {
              background-color: #28a745;
              color: white;
            }

            &.current .step-icon {
              background-color: #e93323;
              color: white;
              animation: pulse 2s infinite;
            }

            .step-content {
              flex: 1;

              h5 {
                font-size: 16px;
                font-weight: 600;
                color: #495057;
                margin-bottom: 5px;
              }

              p {
                font-size: 14px;
                color: #6c757d;
                margin-bottom: 5px;
              }

              .step-date {
                font-size: 12px;
                color: #adb5bd;
              }
            }

            &.completed .step-content h5 {
              color: #28a745;
            }

            &.current .step-content h5 {
              color: #e93323;
            }
          }
        }
      }
    }
  }

  .error-message {
    background-color: #f8d7da;
    color: #721c24;
    padding: 15px;
    border-radius: 4px;
    border: 1px solid #f5c6cb;
    text-align: center;
    margin-top: 20px;
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(233, 51, 35, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(233, 51, 35, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(233, 51, 35, 0);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .track-order {
    padding: 10px;

    .page-header .title {
      font-size: 28px;
    }

    .track-form {
      padding: 20px;
    }

    .order-result .order-card {
      padding: 20px;
    }
  }
}
</style>